var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AccountUtils from '@popup/steem/utils/account.utils';
import ProposalUtils from '@popup/steem/utils/proposal.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import moment from 'moment';
import Config from 'src/config';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import Logger from 'src/utils/logger.utils';
const addToIgnoreRenewal = (usernames) => __awaiter(void 0, void 0, void 0, function* () {
    let ignored = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.GOVERNANCE_RENEWAL_IGNORED);
    if (!ignored) {
        ignored = {};
    }
    for (const username of usernames) {
        ignored[username] = moment().utc().toString();
    }
    yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.GOVERNANCE_RENEWAL_IGNORED, ignored);
});
const removeFromIgnoreRenewal = (username) => __awaiter(void 0, void 0, void 0, function* () {
    let ignored = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.GOVERNANCE_RENEWAL_IGNORED);
    if (!ignored) {
        ignored = {};
    }
    delete ignored[username];
    yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.GOVERNANCE_RENEWAL_IGNORED, ignored);
});
const renewUsersGovernance = (usernames, localAccounts, options) => __awaiter(void 0, void 0, void 0, function* () {
    const promises = [];
    for (const username of usernames) {
        const localAccount = localAccounts.find((localAccount) => localAccount.name === username);
        promises.push(new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const activeAccount = {
                    name: username,
                    keys: { active: localAccount === null || localAccount === void 0 ? void 0 : localAccount.keys.active },
                };
                if (yield ProposalUtils.hasVotedForProposal(activeAccount.name)) {
                    yield ProposalUtils.unvoteProposal(0, activeAccount.name, activeAccount.keys.active, options);
                    yield ProposalUtils.voteForProposal(0, activeAccount.name, activeAccount.keys.active, options);
                }
                else {
                    yield ProposalUtils.voteForProposal(0, activeAccount.name, activeAccount.keys.active, options);
                    yield ProposalUtils.unvoteProposal(0, activeAccount.name, activeAccount.keys.active, options);
                }
                resolve();
            }
            catch (err) {
                Logger.error('Error while renewing proposal', err);
                reject();
            }
        })));
    }
    yield Promise.all(promises);
});
/* istanbul ignore next */
const getGovernanceRenewalIgnored = () => __awaiter(void 0, void 0, void 0, function* () {
    const list = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.GOVERNANCE_RENEWAL_IGNORED);
    return list !== null && list !== void 0 ? list : [];
});
const getGovernanceReminderList = (usernames) => __awaiter(void 0, void 0, void 0, function* () {
    let extendedAccounts = yield AccountUtils.getExtendedAccounts(usernames);
    const ignoredAccounts = yield GovernanceUtils.getGovernanceRenewalIgnored();
    extendedAccounts = extendedAccounts.filter((extendedAccounts) => {
        return (!ignoredAccounts[extendedAccounts.name] ||
            moment(moment().utc()).diff(moment(new Date(ignoredAccounts[extendedAccounts.name])), 'year') >= 1);
    });
    const accountsToRemind = [];
    for (const extendedAccount of extendedAccounts) {
        const governanceExpirationDate = moment(extendedAccount.governance_vote_expiration_ts).utcOffset('+0000', true);
        const diff = moment(governanceExpirationDate).diff(moment().utc(), 'second');
        if (diff <= Config.governanceReminderDelayInSeconds && diff > 0) {
            accountsToRemind.push(extendedAccount.name);
        }
    }
    return accountsToRemind;
});
export const GovernanceUtils = {
    addToIgnoreRenewal,
    renewUsersGovernance,
    getGovernanceRenewalIgnored,
    getGovernanceReminderList,
    removeFromIgnoreRenewal,
};
